module.exports = __webpack_public_path__ + "static/media/dropdown_icon.42d7719d.svg";